module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_7005.674feec9.png";